import { useQuery } from '@tanstack/react-query';
import { getUserOnboardingProgress } from '../services/api/onboardingProgress.js';

export function useUserOnboardingProgress(userId: number) {
  return useQuery({
    queryKey: ['userOnboardingProgress', userId],
    queryFn: () => getUserOnboardingProgress(userId),
    enabled: userId > 0,
  });
}
